<template>
    <div class="main-content align-btn" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-xl-12 col-lg-7 col-md-12 mb-4 pr-lg-4">
                      <h2>Bid Wanted</h2>
                      <div class="ims-tab ml-0" v-if="isOperator">
                        <router-link to="/bidaccumulator/operator">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorAllHoldings' }" >
                            Holdings
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/operator/authorize">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorAuthorize' }" >
                              Trader/Admin Sent
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/operator/bidwanted" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorBidwanted' }" >
                            My Bid Wanted
                          </button>
                        </router-link>
                         <router-link to="/bidaccumulator/operator/allbidwanted" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorAllBidwanted' }" >
                            Operator Bid Wanted
                          </button>
                        </router-link>
                      </div>
                      <div class="ims-tab ml-0" v-if="!isOperator">
                         <router-link to="/bidaccumulator/admin">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorAllHoldings' }" >
                            Holdings
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/admin/authorize">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorAuthorize' }" >
                              Trader Sent
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/admin/bidwanted" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baOperatorBidwanted' }" >
                            Bid Wanted
                          </button>
                        </router-link>
                      </div>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div> 
        
</template>
<script>

export default {
  name: "baholdings",
  components : {

  },
  watch:{
    $route (){
      this.isOperator = window.location.pathname.includes('operator')
    }
  } , 
  data() {
    return {
      isOperator : window.location.pathname.includes('operator')
    };
  },
  methods: {

  },
  mounted() {
  }
};
</script>